<template>
  <div class="flex">
    <form-field-select
      v-model="timeFrame"
      class="mr-75"
      @change="filterChanged"
    >
      <option
        v-for="time in timeFramesOptions"
        :value="time.value"
      >{{ time.label }}</option>
    </form-field-select>

    <form-field-date-picker
      v-if="timeFrame === 'custom'"
      v-model="timeFrameCustomValues"
      is-range
      class="mr-100"
      @change="filterChanged"
    ></form-field-date-picker>

    <filter-field-dropdown
      ref="dropdown"
      :label="campaignFilterLabel"
      icon-left="filter"
    >
      <template>
        <form-field-checkbox-group
          :items="campaigns"
          v-model="campaignIds"
          @selectAll="selectAllCampaigns"
          @deselectAll="deselectAllCampaigns"
        ></form-field-checkbox-group>
      </template>
    </filter-field-dropdown>
  </div>
</template>

<script>
import {timeFrames} from "../../../services/staticData";
import dates from "../../../services/dates";

export default {
  name: "StatsCampaignsFilter",
  data() {
    return {
      timeFrame: 'all_time',
      timeFrameValues: {
        startAt: null,
        endAt: null
      },
      timeFrameCustomValues: [],
      campaignIds: [],
    }
  },
  created() {
    // selects all campaigns if there is no existing filter used by the user
    this.selectAllCampaigns()
  },
  watch: {
    campaignIds() {
      this.filterChanged()
    }
  },
  computed: {
    activeCampaigns() {
      return this.$store.getters.activeCampaigns
    },
    campaignFilterLabel() {
      if (this.campaignIds.length) return `Campaigns (${this.campaignIds.length})`
      return 'Campaigns'
    },
    campaigns() {
      return [...this.activeCampaigns]
    },
    timeFramesOptions() {
      return [
        { value: 'all_time', label: 'All Time', start: null, end: null },
        ...timeFrames,
        { value: 'custom', label: 'Custom', start: null, end: null },
      ]
    },
  },
  methods: {
    selectAllCampaigns() {
      this.campaignIds = this.activeCampaigns.map(c => c.id)
    },
    deselectAllCampaigns() {
      this.campaignIds = []
    },
    filterChanged() {
      const timeFrameValues = timeFrames.find(t => t.value === this.timeFrame);

      if (timeFrameValues) {
        this.timeFrameValues = {
          startAt: timeFrameValues.start,
          endAt: timeFrameValues.end
        }
      } else if (this.timeFrame === 'all_time') {
        this.timeFrameValues = {
          startAt: dates.startOfLastXYears(20),
          endAt: dates.endOfLastXDays(1)
        }
      } else if (this.timeFrame === 'custom') {
        this.timeFrameValues = {
          startAt: dates.convertJsDateToStartOf(this.timeFrameCustomValues[0]),
          endAt: dates.convertJsDateToEndOf(this.timeFrameCustomValues[1]),
        }
      }

      // don't broadcast filter if timeframe values are empty
      if (this.timeFrameValues.startAt === null && this.timeFrameValues.endAt === null) return

      this.$emit('applyFilter', {
        campaignIds: this.campaignIds,
        timeframe: this.timeFrameValues,
      });
    },
  },
}
</script>

<style scoped lang="scss">

</style>
